import React, { useState } from 'react'
import illustrateImage from '../Images/Illustrator.svg'
import bg1 from '../Images/bg1.png'
import bg2 from '../Images/bg2.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { saveSurvey } from '../Http/ApiCalls'
import logo from '../Images/logo.png'
import { useTranslation } from 'react-i18next'

const SubmitPage = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [notSatisfied, setNotSatisified] = useState(false)
    const [userPrice, setUserPrice] = useState('')

    if (!location.state) {
        return (window.location.href = '/')
    }
    const userData = location.state.userData

    const dataObject = {
        userPrice,
        satisfied: notSatisfied ? 'No' : 'Yes'
    }

    const handleSubmit = () => {
        saveSurvey(userData.id, dataObject)
        navigate('/thanks')
    }

    const handleChange = (event) => {
        const value = event.target.value
        setUserPrice(value)
    }

    return (
        <div className="submitPage container-fluid">
            <div className="row">
                <div className="col-5 col-lg-5 col-12">
                    <div className="leftSide">
                        <img
                            src={logo}
                            alt="bglogo"
                            id="logo"
                            className="img-fluid"
                        />
                        <img
                            src={bg2}
                            alt="background"
                            id="bgImage2"
                            className="img-fluid"
                        />
                        <img
                            src={illustrateImage}
                            alt="Illustateimage"
                            id="mainImage"
                            className="img-fluid"
                        />
                        <img
                            src={bg1}
                            alt=""
                            id="bgImage1"
                            className="img-fluid"
                        />
                    </div>
                </div>
                <div className="col-7 col-lg-7 col-12">
                    <div className="rightSide">
                        <h5>@{userData.username}</h5>
                        <h6 style={{ fontWeight: '900' }}>{t('estimatedCost')}</h6>
                        <span style={{ fontWeight: 'bold', fontSize: '32px' }}>{userData.roundedValue} /- </span>
                        <p className="about">{t('illustration')}</p>

                        {!notSatisfied && <h6>{t('satisfiedQuestion')}</h6>}

                        {notSatisfied ? (
                            <>
                                <h6>{t('questionFive')}</h6>
                                <form onSubmit={handleSubmit}>
                                    <label htmlFor="userPrice"></label>
                                    <input
                                        type="number"
                                        name=""
                                        onChange={handleChange}
                                        required
                                        id="userPrice"
                                        placeholder="Enter Amount"
                                    />
                                    <br />
                                    <button
                                        type="submit"
                                        className="singleBtn">
                                        {t('submitBtn')}
                                    </button>
                                </form>
                            </>
                        ) : (
                            <>
                                <button onClick={handleSubmit}>{t('q1op1')}</button>
                                <button
                                    onClick={() => {
                                        setNotSatisified(true)
                                    }}>
                                    {t('q1op2')}
                                </button>
                            </>
                        )}
                        <span className="submitPage-counter">05/05</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubmitPage
